// extracted by mini-css-extract-plugin
module.exports = {"loader":"SearchCardLoader_loader__1fQkg"};